import type { DateFormatterOptions } from "react-aria";
import { useDateFormatter } from "react-aria";

export function FormattedDate({
	date,
	options = {
		month: "short",
		day: "numeric",
		year: "numeric",
	},
	timeZone = "UTC",
}: {
	date: string | Date | number | undefined | null;
	options?: DateFormatterOptions;
	timeZone?: string | undefined;
}) {
	const tz = timeZone;
	const formatter = useDateFormatter({ ...options, timeZone: tz });
	if (!date) {
		return null;
	}

	const parsed = new Date(date);
	if (Number.isNaN(parsed.getTime()) || parsed.getUTCFullYear() <= 1) {
		return <>-</>;
	}

	return <>{formatter.format(parsed)}</>;
}
